import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

export const DEFAULT_LANGUAGE = "pt";
export const SUPPORTED_LANGUAGES = ["pt", "es", "en"];
export const LANGUAGE_STORAGE_KEY = "atomicpay.language";

const localeFiles = import.meta.glob("../locales/*.json", {
  eager: true,
  import: "default",
});

const resources = Object.entries(localeFiles).reduce((acc, [path, messages]) => {
  const language = path.match(/\/([^/]+)\.json$/)?.[1];

  if (language && SUPPORTED_LANGUAGES.includes(language)) {
    acc[language] = { translation: messages };
  }

  return acc;
}, {});

export const normalizeLanguage = (language) => {
  if (!language) return DEFAULT_LANGUAGE;

  const normalized = language.toLowerCase().split("-")[0];
  return SUPPORTED_LANGUAGES.includes(normalized)
    ? normalized
    : DEFAULT_LANGUAGE;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: DEFAULT_LANGUAGE,
    load: "languageOnly",
    defaultNS: "translation",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      convertDetectedLanguage: normalizeLanguage,
    },
    react: {
      useSuspense: false,
    },
  });

i18n.on("languageChanged", (language) => {
  document.documentElement.lang = normalizeLanguage(language);
});

document.documentElement.lang = normalizeLanguage(i18n.resolvedLanguage || i18n.language);

export default i18n;
